"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("core-js/modules/es6.regexp.to-string");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.regexp.replace");
var _user = require("@/api/base/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'Login',
  data: function data() {
    var validatePassword = function validatePassword(rule, value, callback) {
      if (value.length < 6) {
        callback(new Error('密码格式错误'));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        mobile: '',
        password: '',
        app_id: '1'
      },
      loginRules: {
        mobile: [{
          required: true,
          trigger: 'blur'
        }],
        password: [{
          required: true,
          trigger: 'blur',
          validator: validatePassword
        }]
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      redirect: undefined,
      otherQuery: {},
      showLoginForm: false
    };
  },
  watch: {
    $route: {
      handler: function handler(route) {
        var query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true
    }
  },
  created: function created() {
    this.loginByFs();
  },
  mounted: function mounted() {
    if (this.showLoginForm) {
      if (this.loginForm.mobile === '') {
        this.$refs.mobile.focus();
      } else if (this.loginForm.password === '') {
        this.$refs.password.focus();
      }
    }
  },
  methods: {
    checkCapslock: function checkCapslock() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        shiftKey = _ref.shiftKey,
        key = _ref.key;
      if (key && key.length === 1) {
        if (shiftKey && key >= 'a' && key <= 'z' || !shiftKey && key >= 'A' && key <= 'Z') {
          this.capsTooltip = true;
        } else {
          this.capsTooltip = false;
        }
      }
      if (key === 'CapsLock' && this.capsTooltip === true) {
        this.capsTooltip = false;
      }
    },
    showPwd: function showPwd() {
      var _this = this;
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
      this.$nextTick(function () {
        _this.$refs.password.focus();
      });
    },
    handleLogin: function handleLogin() {
      var _this2 = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this2.loading = true;
          _this2.$store.dispatch('user/login', _this2.loginForm).then(function () {
            var allowEnter = _this2.$store.getters.role === 1 || _this2.$store.getters.roles || _this2.$store.getters.ticket;
            if (allowEnter) {
              if (_this2.$route.query.url) {
                window.location.replace("".concat(_this2.$route.query.url, "#/?ticket=").concat(_this2.$store.getters.ticket));
              }
              _this2.$router.push({
                path: '/dashboard/index',
                query: _this2.otherQuery,
                replace: true
              });
            } else {
              _this2.$store.dispatch('user/resetToken');
              _this2.$message.error("\u6682\u65E0\u7CFB\u7EDF\u4F7F\u7528\u6743\u9650");
            }
            _this2.loading = false;
          }).catch(function (err) {
            var msg = err.msg || err;
            _this2.$message.error("\u767B\u5F55\u5931\u8D25:".concat(msg));
            _this2.loading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getOtherQuery: function getOtherQuery(query) {
      return Object.keys(query).reduce(function (acc, cur) {
        if (cur !== 'redirect') {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    loginByFs: function () {
      var _loginByFs = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _this3 = this;
        var isFeishu, code, loginForm, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // 检测是否为飞书环境打开
              isFeishu = window.h5sdk;
              if (!isFeishu) {
                _context2.next = 17;
                break;
              }
              console.log('在飞书客户端中打开');
              // 在这里执行特定于飞书客户端的逻辑
              code = new URL(window.location.href).searchParams.get('code') || localStorage.getItem('code');
              if (!code) {
                _context2.next = 11;
                break;
              }
              this.loading = true;
              loginForm = {
                code: code,
                tm: new Date().getTime().toString(),
                app_id: '1'
              };
              localStorage.setItem('code', code);
              this.$store.dispatch('user/fsLogin', loginForm).then(function () {
                var allowEnter = _this3.$store.getters.role === 1 || _this3.$store.getters.roles || _this3.$store.getters.ticket;
                if (allowEnter) {
                  if (_this3.$route.query.url) {
                    window.location.replace("".concat(_this3.$route.query.url, "#/?ticket=").concat(_this3.$store.getters.ticket));
                  }
                  _this3.$router.push({
                    path: '/dashboard/index',
                    query: _this3.otherQuery,
                    replace: true
                  });
                } else {
                  _this3.$store.dispatch('user/resetToken');
                  _this3.$message.error("\u6682\u65E0\u7CFB\u7EDF\u4F7F\u7528\u6743\u9650");
                }
                _this3.loading = false;
              }).catch( /*#__PURE__*/function () {
                var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(err) {
                  var msg, res;
                  return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        msg = err.msg || err;
                        _this3.$message.error("\u767B\u5F55\u5931\u8D25:".concat(msg));
                        _this3.loading = false;
                        // 如果code过期，重新获取code
                        if (!(err.code === 2001)) {
                          _context.next = 8;
                          break;
                        }
                        _context.next = 6;
                        return (0, _user.getProwerUrl)();
                      case 6:
                        res = _context.sent;
                        window.location.replace(res.data.url);
                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
              _context2.next = 15;
              break;
            case 11:
              _context2.next = 13;
              return (0, _user.getProwerUrl)();
            case 13:
              res = _context2.sent;
              window.location.replace(res.data.url);
            case 15:
              _context2.next = 19;
              break;
            case 17:
              this.showLoginForm = true;
              console.log('在普通浏览器中打开');
              // 在这里执行在普通浏览器中打开的逻辑
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loginByFs() {
        return _loginByFs.apply(this, arguments);
      }
      return loginByFs;
    }()
  }
};
exports.default = _default;